import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
    input{
        border: 1px solid #dee2e6;
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: var(--blueColor1);
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdWaybillInfo({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [editModalOpen, setEditModalOpen] = useState(false);

    const handleReqChange = async (collectionWaybillNumber) => {
        const editableData = _.cloneDeep(returnExchange);

        editableData.collectionWaybillNumber = collectionWaybillNumber;

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            setEditModalOpen(false);
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div>송장번호: {returnExchange?.waybillNumber || '-'}</div>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditModalOpen(true); }}>회수송장번호: {returnExchange?.collectionWaybillNumber || '-'} <span>🛠️</span></span></div>
                </div>
            </StyledTableCell>

            {editModalOpen &&
                <EditModal
                    open={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    onReqChange={handleReqChange}
                />
            }
        </>
    );
}

function EditModal({
    open,
    onClose,
    onReqChange
}) {
    const [value, setValue] = useState('');

    const handleChangeValue = (e) => {
        setValue(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        onReqChange(value);
    }

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
        >
            <StyledModalHeader>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        송장정보 수정
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </StyledModalHeader>
            <form onSubmit={handleSubmit}>
                <StyledModalBody>
                    <CustomLabelInput>
                        <CustomLabelInput.Input
                            type='text'
                            onChange={handleChangeValue}
                            value={value}
                        />
                        <CustomLabelInput.Label style={{ color: 'var(--redColor1)' }}>*회수송장번호</CustomLabelInput.Label>
                    </CustomLabelInput>
                </StyledModalBody>
                <StyledModalFooter>
                    <CustomBlockButton
                        type='submit'
                    >적용</CustomBlockButton>
                </StyledModalFooter>
            </form>
        </CustomDialog>
    );
}